import React from 'react';

export default function StatCard({ title, value, subtitle, color, icon, onClick }) {
  return (
    <div
      className={`stat-card stat-card-${color || 'blue'}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <div className="stat-icon">{icon}</div>
      <div className="stat-body">
        <div className="stat-value">{value ?? '-'}</div>
        <div className="stat-title">{title}</div>
        {subtitle && <div className="stat-sub">{subtitle}</div>}
      </div>
    </div>
  );
}
